<template>
  <div class="my-2 position-relative">
    <!-- آیکون -->
    <div
      v-if="type != 'password'"
      :class="`soha-text-field-icon svg-icon svg-icon-${iconColor}`"
      :style="`${iconPosition}: 10px; cursor: ${iconCursor ? 'pointer' : 'none'}; z-index: ${iconCursor ? '10' : '1'}`"
    >
      <inline-svg
        v-if="icon"
        :src="`/media/svg/soha/icons/${icon}.svg`"
        @click="$emit('onIconClicked', innerValue)"
      />
    </div>

    <!-- FloatLabel برای label floating -->
    <FloatLabel variant="on">
      <Password
        v-if="type === 'password'"
        :id="`textfield-${name || 'default'}`"
        v-model="innerValue"
        :feedback="false" 
        toggle-mask
        :placeholder="placeholder"
        class="w-100 custom-password-input"
        :input-class="['soha-field', { 'p-invalid': error }]"
        :autocomplete="autocomplete"
        :readonly="readonly"
        :maxlength="maxLength"
        :name="name"
        :disabled="disabled"
        size="large"
        @keypress="handleKeyPress"
        @input="onInput"
        @keydown="$emit('keydown', $event)"
        @keypress.enter="onEnterPressedEvent"
        @click="$emit('click', $event)"
        @change="onChangeEvent"
      />
      <InputText
        v-else
        :id="`textfield-${name || 'default'}`"
        v-model="innerValue"
        :name="name"
        :disabled="disabled"
        :type="type === 'number' ? 'text' : type"
        :maxlength="maxLength"
        :class="[
          'w-full',
          icon && iconPosition === 'right' ? 'pr-10' : icon && iconPosition === 'left' ? 'pl-10' : '',
          error ? 'p-invalid' : ''
        ]"
        :autocomplete="autocomplete"
        :readonly="readonly"
        size="large"
        @keypress="handleKeyPress"
        @input="onInput"
        @keydown="$emit('keydown', $event)"
        @keypress.enter="onEnterPressedEvent"
        @click="$emit('click', $event)"
        @change="onChangeEvent"
      />
      <label :for="`textfield-${name || 'default'}`">{{ placeholder }}</label>
    </FloatLabel>

    <!-- نمایش error -->
    <small
      v-if="error"
      class="font-size-sm text-red mt-1 d-block"
    >
      {{ error }}
    </small>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import InputText from 'primevue/inputtext'
import FloatLabel from 'primevue/floatlabel'
import Password from 'primevue/password';

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  disabled: Boolean,
  type: {
    type: String,
    default: "text",
  },
  error: {
    type: String,
    default: null,
  },
  name: {
    type: String,
    default: null,
  },
  maxLength: {
    type: Number,
    default: 255,
  },
  icon: {
    type: String,
    default: null
  },
  iconPosition: {
    type: String,
    default: "right",
  },
  iconCursor: {
    type: Boolean,
    default: false,
  },
  iconColor: {
    type: String,
    default: "primary",
  },
  autocomplete: {
    type: String,
    default: "on",
  },
  readonly: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(["update:modelValue", "onEnterPressed", "onChange", "click", "onIconClicked", 'keydown'])

const innerValue = ref(props.modelValue != null ? String(props.modelValue).trim() : "")

// Watch برای sync با parent
watch(() => props.modelValue, (val) => {
  innerValue.value = val != null ? String(val).trim() : ""
})

// Input handler
const onInput = (event) => {
  innerValue.value = event.target.value
  const trimmed = innerValue.value != null ? String(innerValue.value).trim() : ""
  emit("update:modelValue", trimmed)
}

// Change handler
const onChangeEvent = () => {
  const trimmed = innerValue.value != null ? String(innerValue.value).trim() : ""
  emit("update:modelValue", trimmed)
  emit("onChange", trimmed)
}

// Enter pressed
const onEnterPressedEvent = () => {
  const trimmed = innerValue.value != null ? String(innerValue.value).trim() : ""
  emit("update:modelValue", trimmed)
  emit("onEnterPressed", trimmed)
}

// Number validation
const handleKeyPress = (event) => {
  if (props.type !== 'number') return;

  if (!/[0-9۰-۹]/.test(event.key)) {
    event.preventDefault();
  }
}
</script>

<style scoped>
/* استایل‌های قبلی‌ت رو اینجا نگه دار یا به global منتقل کن */
:deep(.p-inputtext) {
  width: 100% !important;
}

.soha-text-field-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>